import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import Header from '../Header/container'
import ContinueShopping from '../ContinueShopping'
import BodyLayout from './BodyLayout'
import Password from '../ChangePassword/container'

import { showPasswordModal } from '../ChangePassword/actions'
import { customerLogout } from '../Account/actions/apiRequest'

import '../styles/index.scss'

class Layout extends Component {
  handleRouteChane = (id) => {
    const path = `/${id}`
    const { history, handleChangePassword, handleLogout } = this.props

    if (id !== 'changePassword') {
      if (id === 'logout') {
        handleLogout()
      } else history.push(path)
    }
    if (id === 'changePassword') {
      handleChangePassword()
    }
  }

  render() {
    const {
      children, location, restrictedRoute,
    } = this.props
    const activeId = location.pathname.slice(1)
    return (
      <>
        <Header />
        <section className='body-content'>
          <ContinueShopping />
          {
            restrictedRoute
              ? (
                <BodyLayout
                  activeId={activeId}
                  onSelect={(id) => {
                    this.handleRouteChane(id)
                  }}
                >
                  <>
                    <Password />
                    {children}
                  </>
                </BodyLayout>
              )
              : children
          }

        </section>
      </>
    )
  }
}

Layout.propTypes = {
  restrictedRoute: PropTypes.bool.isRequired,
  children: PropTypes.element,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  handleChangePassword: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
}

Layout.defaultProps = {
  children: null,
}

const mapDispatchToProps = (dispatch) => ({
  handleChangePassword: () => {
    dispatch(showPasswordModal())
  },
  handleLogout: () => {
    dispatch(customerLogout())
  },
})

const Index = connect(
  null,
  mapDispatchToProps,
)(Layout)

export default withRouter(Index)
